// This function allow to reference chunks
__webpack_require__.k = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "chunk." + {"7": "d99c908827bd04f7","846": "14657279d864b19b",}[chunkId] + ".css"
}